// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Sheet from "../../primitives/Sheet.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as ApolloConfig from "../../core/ApolloConfig.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Client from "@apollo/client";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query PromotionSheetQuery($id: ID!, $first: Int, $after: String)  {\npromotionCampaign(id: $id)  {\n__typename  \nstartDate  \ndiscounts(first: $first, after: $after)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nvalue  \nkind  \nvariant  {\n__typename  \nid  \nstockKeepingUnit  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.promotionCampaign;
  let tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    let value$2 = value$1.discounts;
    let value$3 = value$2.pageInfo;
    let value$4 = value$3.endCursor;
    let value$5 = value$3.hasNextPage;
    let value$6 = value$2.edges;
    tmp = {
      __typename: value$1.__typename,
      startDate: Scalar.Datetime.parse(value$1.startDate),
      discounts: {
        __typename: value$2.__typename,
        pageInfo: {
          __typename: value$3.__typename,
          endCursor: !(value$4 == null) ? value$4 : undefined,
          hasNextPage: !(value$5 == null) ? value$5 : undefined
        },
        edges: value$6.map(value => {
          let value$1 = value.node;
          let value$2 = value$1.kind;
          let tmp;
          switch (value$2) {
            case "CURRENCY" :
              tmp = "CURRENCY";
              break;
            case "PERCENT" :
              tmp = "PERCENT";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          let value$3 = value$1.variant;
          let value$4 = value$3.stockKeepingUnit;
          return {
            __typename: value.__typename,
            node: {
              __typename: value$1.__typename,
              value: value$1.value,
              kind: tmp,
              variant: {
                __typename: value$3.__typename,
                id: value$3.id,
                stockKeepingUnit: !(value$4 == null) ? value$4 : undefined
              }
            }
          };
        })
      }
    };
  }
  return {
    promotionCampaign: tmp
  };
}

function serialize(value) {
  let value$1 = value.promotionCampaign;
  let promotionCampaign;
  if (value$1 !== undefined) {
    let value$2 = value$1.discounts;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.variant;
      let value$3 = value$2.stockKeepingUnit;
      let stockKeepingUnit = value$3 !== undefined ? value$3 : null;
      let value$4 = value$2.id;
      let value$5 = value$2.__typename;
      let variant = {
        __typename: value$5,
        id: value$4,
        stockKeepingUnit: stockKeepingUnit
      };
      let value$6 = value$1.kind;
      let kind = value$6 === "PERCENT" ? "PERCENT" : "CURRENCY";
      let value$7 = value$1.value;
      let value$8 = value$1.__typename;
      let node = {
        __typename: value$8,
        value: value$7,
        kind: kind,
        variant: variant
      };
      let value$9 = value.__typename;
      return {
        __typename: value$9,
        node: node
      };
    });
    let value$4 = value$2.pageInfo;
    let value$5 = value$4.hasNextPage;
    let hasNextPage = value$5 !== undefined ? value$5 : null;
    let value$6 = value$4.endCursor;
    let endCursor = value$6 !== undefined ? value$6 : null;
    let value$7 = value$4.__typename;
    let pageInfo = {
      __typename: value$7,
      endCursor: endCursor,
      hasNextPage: hasNextPage
    };
    let value$8 = value$2.__typename;
    let discounts = {
      __typename: value$8,
      pageInfo: pageInfo,
      edges: edges
    };
    let value$9 = value$1.startDate;
    let value$10 = Scalar.Datetime.serialize(value$9);
    let value$11 = value$1.__typename;
    promotionCampaign = {
      __typename: value$11,
      startDate: value$10,
      discounts: discounts
    };
  } else {
    promotionCampaign = null;
  }
  return {
    promotionCampaign: promotionCampaign
  };
}

function serializeVariables(inp) {
  let a = inp.first;
  let a$1 = inp.after;
  return {
    id: inp.id,
    first: a !== undefined ? a : undefined,
    after: a$1 !== undefined ? a$1 : undefined
  };
}

function makeVariables(id, first, after, param) {
  return {
    id: id,
    first: first,
    after: after
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_use = include.use;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: Query_use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function makeFilename(name, date, extension) {
  return I18n.t("promotionsexport") + "_" + name.split(" ").join("_") + "_" + I18n.dateTimeFormat(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, date).split("/").join("-") + "." + extension;
}

function makeCsvFilename(name, date) {
  return makeFilename(name, date, Sheet.csvFileExtension);
}

function makeExcelFilename(name, date) {
  return makeFilename(name, date, Sheet.excelFileExtension);
}

function makeRows(promotionCampaign) {
  let discountHeaderRow = [
    I18n.t("Variant ID"),
    "SKU",
    I18n.t("Promotional value"),
    I18n.t("Promotional type")
  ];
  let discountRows = promotionCampaign.map(discount => {
    let match = discount.kind;
    return [
      discount.variantId,
      Stdlib_Option.getOr(discount.variantStockKeepingUnit, ""),
      discount.value.toString().replace(".", ","),
      match === "PERCENT" ? "%" : "eur"
    ];
  });
  return Belt_Array.concatMany([
    [discountHeaderRow],
    discountRows
  ]);
}

function query$1(after, promotionCampaignId, first) {
  return FuturePromise.fromPromise(ApolloConfig.makeClient().rescript_query({
    query: query,
    Raw: Raw,
    parse: parse,
    serialize: serialize,
    serializeVariables: serializeVariables
  }, undefined, undefined, undefined, undefined, {
    id: promotionCampaignId,
    first: first,
    after: after
  }));
}

function queryPromotionDiscountProducts(promotionCampaignId, previousResult, firstOpt, after, param) {
  let first = firstOpt !== undefined ? firstOpt : 50;
  return Future.flatMap(query$1(after, promotionCampaignId, first), undefined, result => {
    if (result.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: "QueryFailure"
      });
    }
    let match = result._0;
    if (match.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: "QueryFailure"
      });
    }
    let match$1 = match._0;
    let campaigns = match$1.data.promotionCampaign;
    if (campaigns === undefined) {
      if (match$1.error !== undefined) {
        return Future.value({
          TAG: "Error",
          _0: "QueryFailure"
        });
      } else {
        return Future.value({
          TAG: "Ok",
          _0: undefined
        });
      }
    }
    if (match$1.error !== undefined) {
      return Future.value({
        TAG: "Error",
        _0: "QueryFailure"
      });
    }
    let promotionCampaign = previousResult !== undefined ? Belt_Array.concatMany([
        previousResult,
        campaigns.discounts.edges.map(param => {
          let discount = param.node;
          return {
            value: discount.value,
            kind: discount.kind,
            variantId: discount.variant.id,
            variantStockKeepingUnit: discount.variant.stockKeepingUnit
          };
        })
      ]) : campaigns.discounts.edges.map(param => {
        let discount = param.node;
        return {
          value: discount.value,
          kind: discount.kind,
          variantId: discount.variant.id,
          variantStockKeepingUnit: discount.variant.stockKeepingUnit
        };
      });
    let match$2 = campaigns.discounts.pageInfo;
    let endCursor = match$2.endCursor;
    if (endCursor !== undefined) {
      let match$3 = match$2.hasNextPage;
      if (match$3 !== undefined && match$3) {
        return queryPromotionDiscountProducts(promotionCampaignId, promotionCampaign, first, endCursor, undefined);
      } else {
        return Future.value({
          TAG: "Ok",
          _0: promotionCampaign
        });
      }
    }
    let match$4 = match$2.hasNextPage;
    if (match$4 !== undefined && match$4) {
      return Future.value({
        TAG: "Error",
        _0: "QueryFailure"
      });
    } else {
      return Future.value({
        TAG: "Ok",
        _0: promotionCampaign
      });
    }
  });
}

function makeCsvPlainText(promotionCampaign) {
  return Sheet.makeCsvPlainText(undefined, makeRows(promotionCampaign));
}

function makeCsvBlob(promotionCampaign) {
  return Stdlib_Result.map(Sheet.makeCsvPlainText(undefined, makeRows(promotionCampaign)), Sheet.makeCsvBlobFromPlainText);
}

function queryAndMakeCsvBlob(promotionCampaignId) {
  return Future.map(queryPromotionDiscountProducts(promotionCampaignId, undefined, undefined, undefined, undefined), undefined, results => {
    if (results.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: results._0
      };
    }
    let discountProducts = results._0;
    if (discountProducts === undefined) {
      return {
        TAG: "Error",
        _0: "NoDataFailure"
      };
    }
    if (discountProducts.length === 0) {
      return {
        TAG: "Error",
        _0: "NoDataFailure"
      };
    }
    let csvBlob = Stdlib_Result.map(Sheet.makeCsvPlainText(undefined, makeRows(discountProducts)), Sheet.makeCsvBlobFromPlainText);
    if (csvBlob.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: csvBlob._0
      };
    } else {
      return {
        TAG: "Error",
        _0: "WriteBlobFailure"
      };
    }
  });
}

function makeExcelBlob(promotionCampaign) {
  return Future.mapError(Sheet.makeExcelBlob(makeRows(promotionCampaign), I18n.t("Promotional campaigns")), undefined, () => "WriteBlobFailure");
}

function queryAndMakeExcelBlob(promotionCampaignId) {
  return Future.flatMap(queryPromotionDiscountProducts(promotionCampaignId, undefined, undefined, undefined, undefined), undefined, result => {
    if (result.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: result._0
      });
    }
    let discountProducts = result._0;
    if (discountProducts !== undefined && discountProducts.length !== 0) {
      return makeExcelBlob(discountProducts);
    } else {
      return Future.value({
        TAG: "Error",
        _0: "NoDataFailure"
      });
    }
  });
}

export {
  Query,
  makeFilename,
  makeCsvFilename,
  makeExcelFilename,
  makeRows,
  query$1 as query,
  queryPromotionDiscountProducts,
  makeCsvPlainText,
  makeCsvBlob,
  queryAndMakeCsvBlob,
  makeExcelBlob,
  queryAndMakeExcelBlob,
}
/* query Not a pure module */
